import { defineStore } from 'pinia'
import { readStationReportTable } from '@/api/api.js'


export const useReportStore = defineStore('reportStore', {
    state: () => ({
		// Map of maps: { metricsId: new Map(), }
		stations: new Map(),
	}),

    getters: {},

    actions: {
		/* Returns day report Array hourly.
		day: Date
		*/
        async getDay(metricsId, day) {
			let stationReports = this._stationReports(metricsId)
			const key = this._dayToKey(day)

			if (!stationReports || !stationReports.has(key)) {
				await this._loadDayFromDb(metricsId, day)
				stationReports = this._stationReports(metricsId)
			}

			return stationReports.get(key)
		},

		async getHour(metricsId, startTime) {
			const stopTime = new Date(startTime.getTime() + (3600 * 1000))
			return await this._loadIntervalFromDb(metricsId, startTime, stopTime)
			// return await this._loadDayFromDb(metricsId, startTime)
		},

		/* Return day after.
		day: Date
		 */
		nextDay(day) {
			const dateObj = new Date(day)
			dateObj.setDate(dateObj.getDate() + 1)
			return dateObj
		},

		/* Return day before.
		day: Date
		*/
		prevDay(day) {
			const dateObj = new Date(day)
			dateObj.setDate(dateObj.getDate() - 1)
			return dateObj
		},

		/* Read report rows for one day.
		day: Date
		*/
		async _loadDayFromDb(metricsId, day) {
			let rows = []

			const dayStart = new Date(day)
			dayStart.setHours(0, 0, 0, 0)

			const dayEnd = new Date(day)
			dayEnd.setHours(23, 59, 59, 999)

			await readStationReportTable(
				metricsId,
				dayStart,
				dayEnd,
				rows,
				'1h',
				10000
			)

			// Create station metrics if can't find
			if (this.stations.get(metricsId) === undefined) {
				this.stations.set(metricsId, new Map())
			}

			// Save rows
			this.stations.get(metricsId).set(this._dayToKey(day), rows)

			return rows
		},

		/* Read report rows for time interval.
		start: Date
		stop: Date
		*/
		async _loadIntervalFromDb(metricsId, start, stop) {
			let rows = []

			await readStationReportTable(
				metricsId,
				start,
				stop,
				rows,
				'1m',
			)
			
			return rows
		},

		/* Return station reports Map or undefined */
		_stationReports(metricsId) {
			return this.stations.get(metricsId)
		},

		/* Return string DD.MM.YYYY
		day: Date
		*/
		_dayToKey(day) {
			return `${String(day.getDate()).padStart(2, "0")}.${String(day.getMonth()+1).padStart(2, "0")}.${day.getFullYear()}`
		},
    },
})
